export const CARD_COLORS = {
  light: {
    default: { label: "Default", color: "default" },
    red: { label: "Red", color: "#ffd4d2" },
    pink: { label: "Pink", color: "#ffd6e7" },
    purple: { label: "Purple", color: "#f2d6ff" },
    blue: { label: "Blue", color: "#d6e4ff" },
    green: { label: "Green", color: "#d9f7be" },
    orange: { label: "Orange", color: "#ffd591" },
    yellow: { label: "Yellow", color: "#ffffb8" },
    cyan: { label: "Cyan", color: "#b5f5ec" },
    gray: { label: "Gray", color: "#f5f5f5" },
  },
  dark: {
    default: { label: "Default", color: "default" },
    red: { label: "Red", color: "#4a2a2d" },
    pink: { label: "Pink", color: "#4a2a32" },
    purple: { label: "Purple", color: "#3a2d45" },
    blue: { label: "Blue", color: "#2a3b4d" },
    green: { label: "Green", color: "#2f432a" },
    orange: { label: "Orange", color: "#4a3d2a" },
    yellow: { label: "Yellow", color: "#4a462a" },
    cyan: { label: "Cyan", color: "#2a3d3f" },
    gray: { label: "Gray", color: "#363636" },
  },
};

export const getCardColor = (colorName, themeMode) => {
  if (!colorName || colorName === "default") {
    return "default";
  }
  return CARD_COLORS[themeMode]?.[colorName]?.color || "default";
};

export const getCardColorOptions = (themeMode) => {
  // Default to light mode if themeMode is invalid or undefined
  const validMode = themeMode && CARD_COLORS[themeMode] ? themeMode : "light";
  const colorMap = CARD_COLORS[validMode];

  // Safety check: ensure colorMap exists and is an object
  if (!colorMap || typeof colorMap !== "object") {
    console.warn(
      `getCardColorOptions: Invalid color map for mode "${validMode}", defaulting to light`
    );
    return Object.entries(CARD_COLORS.light).map(([value, { label }]) => ({
      value,
      label,
    }));
  }

  return Object.entries(colorMap).map(([value, { label }]) => ({
    value,
    label,
  }));
};
